import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import ProfileSettingsCard from "examples/Cards/InfoCards/ProfileSettingsCard";

// Overview page components
import Header from "layouts/user-management-details/components/Header";

import { getProfile, getSingleUser } from "actions/userActions";

// import { useUser } from "contextUserInfo";

function Overview() {
  const dispatch = useDispatch();
  const { id } = useParams();
  // const userData = useUser();

  const singleUser = useSelector((state) => state.singleUser);
  const { userSingle } = singleUser;

  const getMe = useSelector((state) => state.getMe);
  const { me } = getMe;
  console.log("🚀 ~ file: index.js:43 ~ Overview ~ me:", me);

  useEffect(() => {
    // if (me?.length === 0) {
    dispatch(getProfile());
    // }
  }, [dispatch]);

  useEffect(() => {
    dispatch(getSingleUser(id));
  }, [dispatch, userSingle?.length, id]);

  return (
    <DashboardLayout>
      <DashboardNavbar title={`${userSingle?.name}'s Details`} />
      <MDBox mb={2} />
      <Header info={userSingle}>
        <MDBox mt={5} mb={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} xl={4} sx={{ display: "flex" }}>
              <Divider orientation="vertical" sx={{ ml: 1, mr: 3 }} />
              <ProfileInfoCard
                title="Account Information"
                currentInfo={userSingle}
                id={id}
                active={userSingle?.active}
                info={{
                  fullName: userSingle?.name,
                  mobile: userSingle?.phone,
                  idNumber: userSingle?.idNumber,
                  email: userSingle?.email,
                  role: userSingle?.role,
                  joined: moment(userSingle?.created_at).fromNow(),
                }}
                action={{ route: "", tooltip: "Edit Account Information" }}
                shadow={false}
              />
              <Divider orientation="vertical" sx={{ mx: 3 }} />
            </Grid>
            {(me?.role === "super_admin" || me?.role === "admin") && (
              <Grid item xs={12} md={6} xl={4} sx={{ display: "flex" }}>
                <Divider orientation="vertical" sx={{ ml: 1, mr: 3 }} />
                <ProfileSettingsCard
                  title="Account Settings"
                  currentInfo={userSingle}
                  id={id}
                  active={userSingle?.active}
                  info={{
                    fullName: userSingle?.name,
                    mobile: userSingle?.phone,
                    idNumber: userSingle?.idNumber,
                    email: userSingle?.email,
                    role: userSingle?.role,
                    joined: moment(userSingle?.created_at).fromNow(),
                  }}
                  action={{ route: "", tooltip: "Edit Account Information" }}
                  shadow={false}
                />
                <Divider orientation="vertical" sx={{ mx: 3 }} />
              </Grid>
            )}
          </Grid>
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
